import { get } from 'lodash';
import React from 'react';
import { FC, useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import SEOTags from '~/components/SEOTags';
import { RelatedPosition, SectionsKey } from '~/constants/enum';
import Layout from '~/layouts/ThemeLayout';
import { CartAtom } from '~/services/cart';
import { getPageStruct, renderPage } from '~/utils/page';
import { renderSectionByKey } from '~/utils/pageTwo';
import { getTheme } from '~/utils/theme';

const pageStruct = getPageStruct(getTheme(), 'cart');
const sections = pageStruct?.children
    ?.sort((a: any, b: any) => a.order - b.order)
    .map((item: any) => {
        const Section = renderSectionByKey(item.id);

        return {
            id: item.id,
            order: item.order,
            dataKey: item.dataKey,
            component: !!Section ? <Section /> : null
        };
    });

const CartPage: FC = () => {
    const { cartId } = useRecoilValue(CartAtom.cartSelector);
    const sectitonData = {
        [SectionsKey.Related]: {
            type: 'cart',
            cartId: cartId,
            position: RelatedPosition.CartContentBottom
        }
    };

    return (
        <Layout isUseMinHeight={false}>
            <SEOTags title="Cart" />
            <div>
                {sections.map((section: any, index: number) => {
                    const Section = section.component;
                    return (
                        <React.Fragment key={`section-${index}`}>
                            {React.isValidElement(Section)
                                ? React.cloneElement(Section as React.ReactElement, {
                                      ...get(sectitonData, section.dataKey, {})
                                  })
                                : Section}
                        </React.Fragment>
                    );
                })}
            </div>
        </Layout>
    );
};

export default CartPage;
